import React from "react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { Box, Flex, HStack, IconButton, useOutsideClick } from "@chakra-ui/react";
import type { IHeaderProps } from "../../index";
import { ReactComponent as NavBarLogoPay } from "../..../../../../../assets/icons/navBarLogoPay.svg";
import MenuList from "./MenuList";
import { observer } from "mobx-react-lite";
import { useAnalytics } from "../../../../hooks";

const Menu: React.FC<IHeaderProps> = observer(({ contents }) => {
	const ref = React.useRef(null);
	const [isOpen, setIsOpen] = React.useState<boolean>(false);
	const { addAnalyticEvent, updatePageView } = useAnalytics();

	useOutsideClick({
		ref,
		handler: () => setIsOpen(false),
	});

	const renderMenuIcon = (open: boolean): JSX.Element => {
		if (open) {
			return <CloseIcon p={"6px"} boxSize={"24px"} color={"black"} />;
		}
		return <HamburgerIcon color={"black"} w="fit-content" boxSize={"24px"} />;
	};

	const handleTriggerTagging = (): void => {
		if (isOpen) {
			return;
		}

		addAnalyticEvent(
			{
				component: "body",
				action: "click:menu",
				step: "home:menu",
				description: "Menu Options",
				value: "",
			},
			{applySanitize: true},
		);

		updatePageView({
			name: "Vivo Money Menu",
			pagePath: "/menu",
		});
	};

	return (
		<Flex w={"100%"} h={"100%"} ref={ref}>
			<HStack
				width={"100%"}
				gap={"24px"}
				p={"8px 16px"}
				borderBottom={"1px"}
				borderColor={"white.200"}
				position={"absolute"}
				zIndex={999}
				bg={"white"}
			>
				<IconButton
					aria-label="Menu Options"
					icon={renderMenuIcon(isOpen)}
					bg="white"
					_hover={{ bg: "transparent" }}
					_focus={{ bg: "transparent" }}
					_active={{ bg: "transparent" }}
					boxSize={"24px"}
					paddingInline={0}
					onClick={() => {
						handleTriggerTagging();
						setIsOpen((prevState) => !prevState);
					}}
					size={"xs"}
					ref={ref}
				/>
				<IconButton
					bg={"transparent"}
					as={NavBarLogoPay}
					aria-label={"Vivo Logo"}
					h={"40px"}
					paddingInline={0}
					_hover={{ bg: "transparent", cursor: "pointer" }}
					_active={{ bg: "transparent" }}
					onClick={() => window.open("https://vivomoney.com.br", "_self")}
				/>
			</HStack>
			<Box ref={ref}>
				<MenuList contents={contents} isOpen={isOpen} setIsOpen={setIsOpen} />
			</Box>
		</Flex>
	);
});

export default Menu;
